

import { defineComponent } from 'vue';
import { NInput } from 'naive-ui';

import modalBase from './modal-base';

export default defineComponent({

    extends: modalBase,

    components: {
        NInput,
    },

    data() {
        return {
            title: '',
            options: {},
            promptValue: null,
            valid: true,
        }
    },

    mounted(): void {
        this.$eventBus.on('prompt.open', (options: { title: string, options: Record<string, string | number>}) => {
            this.title = options.title;
            this.options = options.options ? options.options: {};
            console.log('mounted.on.prompt-open', this.options);
            this.open();
        })
    },

    unmounted(): void {
        console.log('prompt-modal.unmounted');
        this.$eventBus.off('prompt.open');
    },

    methods: {
        submit(): void {

            if(!this.promptValue) {
                return;
            }

            this.$eventBus.emit('prompt.submit', this.promptValue);
            this.promptValue = null;
            this.close(true);
        },

        onClosed(): void {
            this.$eventBus.emit('prompt.close')
        }
    },
});
